import { ConstructPost } from '../../../types/ConstructPost';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postResetUserTwoFactor = (
  constructPost: ConstructPost,
  userId: string,
): Promise<unknown> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/users/${userId}/reset-two-factor`,
    undefined,
    { preventDefaultErrorToast: true },
  );
